export const messageOr = (custom: string | undefined, defaultText: string): string => {
  return custom?.trim() ? custom : defaultText;
};
